

























































































































































































































































import axios, { AxiosResponse } from 'axios';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { General } from '@/services/General'
import { CreationCountryDto, CreationCommunicationDto, CreationAttachmentDto } from '@/interfaces/creationCommunicationDto'
import { ReadingCountryDto, LocationDto } from '@/interfaces/readingCommunicationDto'
import CommunicationCategory from '@/services/CommunicationCategory'
import { ICommunicationSubCategory } from '@/interfaces/ICommunicationSubCategory'
import CommunicationGenericDocuments from '@/components/CommunicationGenericDocuments.vue'
import CommunicationShow from '@/components/CommunicationShow.vue';
import { UpdatingAttachmentDto, UpdatingCommunicationDto, UpdatingCountryDto } from '@/interfaces/updatingCommunicationDto'
import { VueEditor } from "vue2-editor";
import { ClaimEnum } from '@/services/ClaimEnum';
import { saveAs } from 'file-saver';
import ImageResize from 'quill-image-resize-module';
import { ImageDrop } from 'quill-image-drop-module';
import CommunicationWidgetDto from "@/services/CommunicationWidgetDto";



interface CommunicationTypeResult {
    id: string
    name: string
    mustHaveText: boolean
    canHaveText: boolean
    mustHaveTitle: boolean
    canHaveTitle: boolean
    canHaveAttachments: boolean
    canHaveLink: boolean
    mustHaveLink: boolean
    isActiveReadingConfirmation: boolean
}

interface ReadingConfirmationResult {
    id: string
    isMandatory: boolean
    //isActive: boolean
    isAcknowledgment: boolean
    rowVersion: any
}

interface CommunicationSearchResult {
    id: string
    numericId: number
    text: string
    title: string
    author: string
    creationDate: Date
    startDisplayDate: Date
    endDisplayDate: Date
    rowVersion: any
    //linkName: string
    linkUrl: string
    sendEmailNotification: boolean
    //communicationType: CommunicationTypeResult
    category: CommunicationCategory
    subCategory: ICommunicationSubCategory
    readingConfirmation: ReadingConfirmationResult
}



interface CommunicationTableField {
    key: string
    label: string
    sortable: boolean
}




interface SpecificInfo {
    attachments: Array<AttachmentSearchResult>
    countries: Array<CountrySearchResult>
    locations: Array<CommunicationLocation>
}

interface CountrySearchResult {
    id: string
    name: string
    code: string
    isInternal: boolean
    isExternal: boolean
}

interface CommunicationLocation{
    communicationId: string
    isExternal: boolean
    isInternal: boolean
    locationId: string
}

interface AttachmentSearchResult {
    id: string
    name: string
    rowVersion: any
}

interface CompleteCommunicationInfo {
    readingCommunicationDto: CommunicationSearchResult
    specificInfoDto: SpecificInfo
}

interface CommunicationOption {
    value: string
    text: string
}



interface CountriesShowed {
    idCountry: string,
    name: string,
    code: string,
    INTERNAL: boolean,
    EXTERNAL: boolean,
    showLocations: boolean;
    locations: Array<LocationDto>
}

@Component({
    components: {
        CommunicationGenericDocuments,
        VueEditor,
        CommunicationShow

    }
})
export default class CommunicationDetail extends Vue {
    @Prop()
    public id!: string;
    contractTypesOptions: any = null;

    previewData: CommunicationWidgetDto = null;

    CLICKABLE_SEARCH_ICON = "fa fa-search clickable"
    MODAL_ID = "communication-modal";
    MODAL_PREVIEW_ID = "communication-preview-modal";

    get customModulesForEditor() {
        return [
            { alias: "imageResize", module: ImageResize },
            { alias: "imageDrop", module: ImageDrop }

        ]
    }
    get editorSettings() {
        return {
            modules: {
                imageResize: {
                    toolbarButtonStyles: {
                        display: "none"
                    }
                }
            }
        }
    }

    get previewTitle() {
        if (!this.previewData) return null;
        return this.previewData.title;

    }


    get customToolbar() {
        return [
            [{ header: [false, 1, 2, 3, 4, 5, 6] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "video", "image"],
            [
                { align: "" },
                { align: "center" },
                { align: "right" },
                { align: "justify" }
            ],
            ["clean"]

        ]
    }
    isSaveClicked: boolean = false;
    confirmationTypeOptions: Array<any> = [
        { value: null, text: 'Please select an option' }, { value: false, text: 'Acceptance/Rejection' }, { value: true, text: 'Acknowledgment' }
    ]
    loadingModal: boolean = false
    communicationCategoriesOptions: Array<CommunicationOption> = [];
    communicationSubCategoriesOptions = new Array();
    // defaultCategoryOption: CommunicationOption = {
    //         text: "Please select an option!",
    //         value: ""
    //     }

    communicationCategoriesAvailable: Array<CommunicationCategory> = []
    communicationSubCategoriesAvailable: Array<ICommunicationSubCategory> = []
    formChanged: boolean = false
    requiredFields: boolean = false
    countryList: Array<CountriesShowed> = [];
    countryListCommunication: Array<CountrySearchResult> = [];
    selectAllCheckbox: Array<boolean> = [];
    completeCommunicationInfo: CompleteCommunicationInfo = null;
    communicationCountryFields: Array<CommunicationTableField> = [
        {
            key: "name",
            label: "Name",
            sortable: false
        },
        {
            key: "checkbox",
            label: "",
            sortable: false
        }
    ]
    communicationCountryValues: boolean[] = []
    countryCheckboxCount = 0
    attachmentToSave: Array<UpdatingAttachmentDto> = [];

    quillEditor: null;
    userCanManageCommunications: boolean = false;

    isInstantEmailSenderButtonVisibile(newComm: boolean) {
        if (newComm) {
            return this.id == null && (this.completeCommunicationInfo.readingCommunicationDto.sendEmailNotification != null && this.completeCommunicationInfo.readingCommunicationDto.sendEmailNotification.toString() === 'true');
        } else {
            return this.id != null && (this.completeCommunicationInfo.readingCommunicationDto.sendEmailNotification != null && this.completeCommunicationInfo.readingCommunicationDto.sendEmailNotification.toString() === 'true');
        }
    }

    async changeCommunicationCategory(idCategorySelected: string) {
        this.completeCommunicationInfo.readingCommunicationDto.subCategory.idSubCategory = null;
        if (this.communicationSubCategoriesOptions.length > 0)
            this.communicationSubCategoriesOptions.splice(0);
        await this.setSubCategoriesOptions(idCategorySelected);
        this.setCommunicationCategory(idCategorySelected);
        this.resetField();
        this.isSaveClicked = false;
    }
    openPreview() {

        let commDetail = new CommunicationWidgetDto();
        commDetail.idCommunication = this.completeCommunicationInfo.readingCommunicationDto.id;
        commDetail.text = this.completeCommunicationInfo.readingCommunicationDto.text;
        commDetail.title = this.completeCommunicationInfo.readingCommunicationDto.title;
        commDetail.creationDate = this.completeCommunicationInfo.readingCommunicationDto.creationDate;
        commDetail.linkName = this.completeCommunicationInfo.readingCommunicationDto.title;
        commDetail.linkUrl = this.completeCommunicationInfo.readingCommunicationDto.linkUrl;
        commDetail.attachments = this.convertToAttachments(this.attachmentToSave, this.completeCommunicationInfo.specificInfoDto.attachments);


        this.previewData = commDetail;


        this.$bvModal.show(this.MODAL_PREVIEW_ID);

    }
    convertToAttachments(attachmentsTemp: any[], attachmentSaved: any[]) {

        let outputAttach = new Array<any>();

        attachmentSaved.forEach(el => {

            outputAttach.push({
                id: el.id,
                name: el.name,
                rowVersion: el.rowVersion
            });
        });
        attachmentsTemp.forEach(el => {


            outputAttach.push({
                id: el.Id,
                name: el.Name,
                rowVersion: el.RowVersion,
                sessionId: el.SessionId
            })

        });

        return outputAttach;
    }
    handleImageAdded(file, Editor, cursorLocation) {
        var formData = new FormData();

        let fileType = "image"
        formData.append(fileType, file);

        axios({
            url: General.GetApiUrl("/api/General/StoreInternalFile/" + fileType),
            //url: General.GetApiUrl("/api/General/GetPathFileById/93BF83A9-7372-418F-BF69-49A901E780BD/Nicola"),
            method: "post",
            data: formData,
            withCredentials: true
        })
            .then(result => {
                const url = result.data; // Get url from response
                if (cursorLocation === null) {
                    cursorLocation = Editor.getSelection();
                }
                Editor.insertEmbed(cursorLocation.index, "image", url);
                //resetUploader();
            })
            .catch(err => {
                console.log(err);
            });


    }
    showLocations(country) {

        country.showLocations = !country.showLocations

        if (country.showLocations) {
            country.locations.forEach(item => {
                item.INTERNAL = country.INTERNAL;
                item.EXTERNAL = country.EXTERNAL;
            });
        } else {
            let selectAllInternal = true;
            let selectAllExternal = true;
            country.locations.forEach(item => {
                if (item.INTERNAL == false)
                    selectAllInternal = false;

                if (item.EXTERNAL == false)
                    selectAllExternal = false;
            });
            country.INTERNAL = selectAllInternal;
            country.EXTERNAL = selectAllExternal;
        }

    }
    changeUncheckedValue(contract: any) {
        let allSelected = true;

        this.countryList.forEach(item => {
            if (item[contract.value] != true) {

                allSelected = false;

            }

        });

        Vue.set(contract, 'selected', allSelected);
    }
    changeUncheckedValueLocation(contract: any) {




        let allSelected = true;
        this.countryList.forEach(singleCheckBox => {

            singleCheckBox.locations.forEach(item => {

                if (item[contract.value] != true) {

                    allSelected = false;
                }
            });

        });



        Vue.set(contract, 'selected', allSelected);

    }

    changeCommunicationSubCategory(value: string) {
        this.completeCommunicationInfo.readingCommunicationDto.subCategory.idSubCategory = value;
    }

    async downloadUserConfirmation() {
        try {
            let response = await axios({
                method: 'get',
                url: General.GetApiUrl("/api/communication/DownloadReadingConfirmations?idCommunication=" + this.completeCommunicationInfo.readingCommunicationDto.id),
                withCredentials: true,
                responseType: 'blob'
            });
            let fileName = General.getFileNameFromHeader(response.headers);

            saveAs(new Blob([response.data]), fileName);
        } catch (error) {
            General.showAlertDanger("Download error, please retry. If the problem stll present contact your IT", this);
        }

    }

    // setCommunicationSubCategory(idSubCategorySelected:string){
    //     this.completeCommunicationInfo.readingCommunicationDto.subCategory = this.communicationSubCategoriesAvailable.find(el=>el.idSubCategory==idSubCategorySelected);
    // }

    deleteCommunication() {
        General.confirm(
            "Do you want to delete current communication?",
            this,
            async () => {
                await this.deleteDo();
                this.closeDetailModal();
                if (this.$route.params.numericId)
                    this.$router.push("/communications");
            }
        );

    }
    closeDetailModal() {
        this.$bvModal.hide(this.MODAL_ID)

    }
    async deleteDo() {
        try {
            this.isSaveClicked = true;
            await axios.delete(
                General.GetApiUrl(
                    "/api/communication/DeleteCommunication?id=" + this.completeCommunicationInfo.readingCommunicationDto.id
                ),
                { withCredentials: true }
            );
            General.showAlertSuccess("Communication successfully removed", this);
        } catch (ex) {
            General.HandleError(ex, this);
        } finally {
            this.isSaveClicked = false;
        }

    }
    resetField() {
        this.completeCommunicationInfo.readingCommunicationDto.text = null;
        //this.completeCommunicationInfo.readingCommunicationDto.linkName = null;
        this.completeCommunicationInfo.readingCommunicationDto.linkUrl = null;
        this.completeCommunicationInfo.readingCommunicationDto.startDisplayDate = null;
        this.completeCommunicationInfo.readingCommunicationDto.endDisplayDate = null;
        this.completeCommunicationInfo.readingCommunicationDto.title = null;
    }

    async setSubCategoriesOptions(idCategory: string) {
        let subCategories = await this.GetCommunicationSubCategoriesWithFilter({ IdCategory: idCategory });
        this.setOptions(this.communicationSubCategoriesOptions, subCategories, "idSubCategory", "name", false);
    }

    setCommunicationCategory(idCategorySelected: string) {
        this.completeCommunicationInfo.readingCommunicationDto.category = this.communicationCategoriesAvailable.find(el => el.idCategory == idCategorySelected);
    }

    async getContractTypes(): Promise<any> {
        this.loadingModal = true;
        try {
            let response = await axios.get<any>(General.GetApiUrl("/api/communication/GetAllContractTypes"), { withCredentials: true })
            if (response.data)
                return response.data;
        } catch (exception) {
            General.HandleError(exception, this);
        } finally {
            this.loadingModal = false;
        }
    }


    setAttachment(attachment) {
        this.attachmentToSave.push({
            Id: null,
            IsChanged: true,
            Name: attachment.name,
            SessionId: attachment.sessionId,
            RowVersion: null,
            ToDelete: false

        });


    }
    acceptTitleInput(): boolean {
        if (this.completeCommunicationInfo.readingCommunicationDto.category.communicationType.mustHaveTitle && !this.completeCommunicationInfo.readingCommunicationDto.title || this.completeCommunicationInfo.readingCommunicationDto.title == "")
            return false;
        else return true;
    }

    acceptLinkInput(isLinkName?: boolean): boolean {
        if (this.completeCommunicationInfo.readingCommunicationDto.category.communicationType.mustHaveLink) {
            if (!this.completeCommunicationInfo.readingCommunicationDto.title && !this.completeCommunicationInfo.readingCommunicationDto.linkUrl)
                return false;
        }
        if (isLinkName) {
            if ((!this.completeCommunicationInfo.readingCommunicationDto.title && this.completeCommunicationInfo.readingCommunicationDto.linkUrl))
                return false;
            else return true;
        }
        if (!isLinkName) {
            if (this.completeCommunicationInfo.readingCommunicationDto.title && !this.completeCommunicationInfo.readingCommunicationDto.linkUrl)
                return false;
            else return true;
        }
    }

    removeAttachment(attachment) {

        this.attachmentToSave.forEach(el => {
            if (attachment.sessionId != null && el.SessionId == attachment.sessionId) {
                el.ToDelete = true;
            }

        });

        if (!this.attachmentToSave.find(el => el.SessionId == attachment.sessionId) || attachment.sessionId == null) {



            this.attachmentToSave.push({
                Id: attachment.id,
                IsChanged: true,
                RowVersion: null,
                Name: null,
                SessionId: attachment.sessionId,
                ToDelete: true

            });
        }

    }

    async viewCommunicationDetail(communicationId: string): Promise<void> {



        if (communicationId != null) {
            this.loadingModal = true;

            try {
                let app = this;
                this.completeCommunicationInfo = (await axios.get<CompleteCommunicationInfo>(
                    General.GetApiUrl('/api/Communication/GetDetailedCommunicationInfo?Id=' + communicationId),
                    {
                        withCredentials: true,
                        responseType: 'json'
                    }
                )).data;

                this.countryListCommunication = app.completeCommunicationInfo.specificInfoDto.countries;
                //console.log(app.completeCommunicationInfo.specificInfoDto)
                                
                this.countryList.forEach(item => {
                    
                    app.completeCommunicationInfo.specificInfoDto.locations.forEach(el => {
                        
                        item.locations.forEach(element => {
                            

                            if (element.id == el.locationId){
                                element.EXTERNAL = el.isExternal;
                                element.INTERNAL = el.isInternal;     
                                item.showLocations = true;                           
                            }

                        });                        

                    });

                    app.completeCommunicationInfo.specificInfoDto.countries.forEach(el => {


                        if (item.name == el.name) {
                            item.INTERNAL = el.isInternal;
                            item.EXTERNAL = el.isExternal;
                            

                        };

                    })



                });


                this.contractTypesOptions.forEach(element => {
                    this.changeUncheckedValue(element)
                });

            } catch (e) {

                General.showAlertDanger("Something Went Wrong!", this)


            } finally {
                if (!this.completeCommunicationInfo.readingCommunicationDto.subCategory)
                    this.completeCommunicationInfo.readingCommunicationDto.subCategory = {
                        idSubCategory: null,
                        idCategory: null,
                        name: null,
                        communicationCategory: new CommunicationCategory()
                    }
                this.loadingModal = false
            }

        }
    }

    async fetchCommunicationCategories() {
        if (this.communicationCategoriesOptions.length <= 1) {
            let response = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/Communication/GetCommunicationCategoriesWithFilter'),
                responseType: 'json',
                withCredentials: true,
                data: {
                    IdCategory : null,
                    TypeId : null,
                    Name : null
                }
            });

            let communicationCategories = response.data;
            
            let fetchedCommunicationCategories: Array<CommunicationOption> = []
            communicationCategories.forEach((communicationCategory: CommunicationCategory) => {
                fetchedCommunicationCategories.push({ text: communicationCategory.name, value: communicationCategory.idCategory })
            })
            this.communicationCategoriesAvailable = communicationCategories
            this.communicationCategoriesOptions = this.communicationCategoriesOptions.concat(fetchedCommunicationCategories)
        }
    }



    async GetCommunicationSubCategoriesWithFilter(filter = null): Promise<[ICommunicationSubCategory]> {
        this.loadingModal = true;
        try {
            let response = await axios({
                method: "post",
                url: General.GetApiUrl("/api/communication/GetCommunicationSubCategoriesWithFilter"),
                data: {
                    IdCategory: filter.IdCategory,
                    IdSubCategory: filter.IdSubCategory,
                    Name: filter.name
                },
                withCredentials: true
            });
            if (response.data)
                return response.data;
        } catch (exception) {
            this.$fire({
                title: "Error ",
                text: exception.response.data,
                type: "error"
            });
        }
        finally {
            this.loadingModal = false;
        }
    }

    genericErrorIspector(): boolean {
        if (this.completeCommunicationInfo.readingCommunicationDto.readingConfirmation.isMandatory && this.completeCommunicationInfo.readingCommunicationDto.readingConfirmation.isAcknowledgment == null) {
            General.showAlertDanger("Please if this communication is mandatory define reading confirmation type for it", this);
            return false;
        }


        if (this.completeCommunicationInfo.readingCommunicationDto.subCategory)
            if (!this.completeCommunicationInfo.readingCommunicationDto.subCategory.idSubCategory && this.communicationSubCategoriesOptions.length > 0) {
                General.showAlertDanger("Please select SubCategory for this new Communication", this);
                return false;
            }

        if (this.completeCommunicationInfo.readingCommunicationDto.category.communicationType.mustHaveLink && !this.completeCommunicationInfo.readingCommunicationDto.linkUrl && !this.completeCommunicationInfo.readingCommunicationDto.title) {
            General.showAlertDanger("Title & LinkUrl are required for this communicationType!", this);
            return false;
        }

        if (this.completeCommunicationInfo.readingCommunicationDto.category.communicationType.mustHaveLink && !this.completeCommunicationInfo.readingCommunicationDto.linkUrl && this.completeCommunicationInfo.readingCommunicationDto.title) {
            General.showAlertDanger("This communication must have link url!. Please define that.", this);
            return false;
        }
        if (this.completeCommunicationInfo.readingCommunicationDto.category.communicationType.mustHaveTitle && !this.completeCommunicationInfo.readingCommunicationDto.title || this.completeCommunicationInfo.readingCommunicationDto.title == "" || (this.completeCommunicationInfo.readingCommunicationDto.category.communicationType.mustHaveLink && !this.completeCommunicationInfo.readingCommunicationDto.title && this.completeCommunicationInfo.readingCommunicationDto.linkUrl)) {
            General.showAlertDanger("Title are required for this communicationType", this);
            return false;
        }

        if (this.completeCommunicationInfo.readingCommunicationDto.category.communicationType.mustHaveText && !this.completeCommunicationInfo.readingCommunicationDto.text || this.completeCommunicationInfo.readingCommunicationDto.text == "") {
            General.showAlertDanger("Text are required for this communicationType", this);
            return false;
        }

        if (!this.completeCommunicationInfo.readingCommunicationDto.category.idCategory) {
            General.showAlertDanger("Please select category for this communication", this);
            return false;
        }

        if (this.completeCommunicationInfo.readingCommunicationDto.sendEmailNotification == null || this.completeCommunicationInfo.readingCommunicationDto.sendEmailNotification.toString() === '') {
            General.showAlertDanger("Please select if system must send an e-mail notification or not", this);
            return false;
        }
        console.log("checking...")
        let checkCountriesOrLocations = this.checkCountriesOrLocationsSelected(this.countryList);
        if (!checkCountriesOrLocations) {
            General.showAlertDanger("Please select at least allowed country or location", this);
            return false;
        }
        //let countries = this.getSelectedCountriesDtoCreation(this.countryList)
        //console.log(countries)
/*
        
        if (countries.length == 0) {
            General.showAlertDanger("Please define 1 ", this);
            return false;
        }
*/
/*
        let countriesSelected = this.getSelectedCountriesDtoUpdating(this.countryList, this.countryListCommunication);
        if (countriesSelected == null || countriesSelected.length == 0) {
            General.showAlertDanger("Please select at least allowed country", this);
            return false;
        }
*/
        return true;
    }
    saveCommunicationChanges(sendMail: boolean = false) {
        let message = "Do you want to save current communication";
        if (sendMail)
            message = message + " and send E-MAILs immediately?";
        else
            message = message + "?";

        General.confirm(
            message,
            this,
            async () => {

                await this.saveCommunicationChangesDo(sendMail);


            }
        );

    }
    async saveCommunicationChangesDo(sendMail: boolean = false) {
        this.isSaveClicked = true;       
        if (this.genericErrorIspector()) {

            let communication: UpdatingCommunicationDto = {
                Id: this.completeCommunicationInfo.readingCommunicationDto.id,
                NumericId: this.completeCommunicationInfo.readingCommunicationDto.numericId,
                Title: this.completeCommunicationInfo.readingCommunicationDto.title,
                Text: this.completeCommunicationInfo.readingCommunicationDto.text,
                StartDisplayDate: this.completeCommunicationInfo.readingCommunicationDto.startDisplayDate,
                EndDisplayDate: this.completeCommunicationInfo.readingCommunicationDto.endDisplayDate,
                //LinkName: this.completeCommunicationInfo.readingCommunicationDto.linkName,
                LinkUrl: this.completeCommunicationInfo.readingCommunicationDto.linkUrl,
                SendEmailNotification: this.completeCommunicationInfo.readingCommunicationDto.sendEmailNotification,
                Category: this.completeCommunicationInfo.readingCommunicationDto.category,
                SubCategory: this.completeCommunicationInfo.readingCommunicationDto.subCategory,
                ReadingConfirmation: {
                    Id: this.completeCommunicationInfo.readingCommunicationDto.readingConfirmation.id,
                    IsAcknowledgment: this.completeCommunicationInfo.readingCommunicationDto.readingConfirmation.isAcknowledgment,
                    IsChanged: true,
                    IsMandatory: this.completeCommunicationInfo.readingCommunicationDto.readingConfirmation.isMandatory,
                    RowVersion: this.completeCommunicationInfo.readingCommunicationDto.readingConfirmation.rowVersion

                },
                RowVersion: this.completeCommunicationInfo.readingCommunicationDto.rowVersion,
                IsChanged: true,
                Attachments: this.getAttachmentDtoUpdating(this.attachmentToSave),
                CommunicationCountries: this.getSelectedCountriesDtoUpdating(this.countryList, this.countryListCommunication)
            }

            let queryArg = '';
            if (sendMail)
                queryArg = '?sendMail=true'

            try {
                console.log(communication)
                await axios.post<CommunicationSearchResult>(

                    General.GetApiUrl('/api/Communication/UpdateCommunication' + queryArg),
                    communication,
                    {
                        withCredentials: true,
                        responseType: 'json'
                    }
                );
                this.closeDetailModal();
                General.showAlertSuccess("Update successfully completed!", this)

            } catch (e) {

                General.showAlertDanger("", this)
            }

        }
    }

    returnState(condiction: boolean, eventCondiction: boolean): boolean {
        if (eventCondiction)
            return condiction
        else return null;
    }



    async getCountries(asManagerOnly: boolean = false): Promise<Array<CountriesShowed>> {
        try {

            let countries: Array<ReadingCountryDto> = (await axios.get<Array<ReadingCountryDto>>(
                General.GetApiUrl('/api/Communication/GetCountriesForUser?asManagerOnly=' + asManagerOnly)
                , {
                    withCredentials: true,
                    responseType: 'json'
                }
            )).data

            let countriesShowed: Array<CountriesShowed> = new Array();
            countries.forEach(country => {
                countriesShowed.push({
                    idCountry: country.idCountry,
                    name: country.name,
                    code: country.code,
                    showLocations: false,
                    INTERNAL: false,
                    EXTERNAL: false,
                    locations: country.locations
                })
            });



            return countriesShowed;
        } catch (e) {

            General.showAlertDanger("Cannot retrieve the list of countries!", this)
        }
    }
    createCommunication(sendMail: boolean = false) {
        let message = "Do you want to create this new communication";
        if (sendMail)
            message = message + " and send E-MAILs immediately?";
        else
            message = message + "?";

        General.confirm(
            message,
            this,
            async () => {

                await this.createCommunicationDo(sendMail);


            }
        );

    }
    async createCommunicationDo(sendMail: boolean = false): Promise<void> {
        this.isSaveClicked = true;
        if (this.genericErrorIspector()) {
            let communication: CreationCommunicationDto = {
                Title: this.completeCommunicationInfo.readingCommunicationDto.title,
                Text: this.completeCommunicationInfo.readingCommunicationDto.text,
                StartDisplayDate: this.completeCommunicationInfo.readingCommunicationDto.startDisplayDate,
                EndDisplayDate: this.completeCommunicationInfo.readingCommunicationDto.endDisplayDate,
                //LinkName: this.completeCommunicationInfo.readingCommunicationDto.linkName,
                LinkUrl: this.completeCommunicationInfo.readingCommunicationDto.linkUrl,
                SendEmailNotification: this.completeCommunicationInfo.readingCommunicationDto.sendEmailNotification,
                ReadingConfirmation: {
                    IsMandatory: this.completeCommunicationInfo.readingCommunicationDto.readingConfirmation.isMandatory,
                    IsAcknowledgment: (!this.completeCommunicationInfo.readingCommunicationDto.readingConfirmation.isAcknowledgment) ? false : this.completeCommunicationInfo.readingCommunicationDto.readingConfirmation.isAcknowledgment

                },
                IdCategory: this.completeCommunicationInfo.readingCommunicationDto.category.idCategory,
                IdSubCategory: this.completeCommunicationInfo.readingCommunicationDto.subCategory.idSubCategory,
                Attachments: this.getAttachmentDtoCreating(this.attachmentToSave),
                CommunicationCountries: this.getSelectedCountriesDtoCreation(this.countryList)

                //this.completeCommunicationInfo.specificInfoDto.attachments,
                //CommunicationCountries: communicationCountries
            }
            let queryArg = '';
            if (sendMail)
                queryArg = '?sendMail=true'

            try {
                let communicationResult: CommunicationSearchResult = (await axios.post<CommunicationSearchResult>(
                    General.GetApiUrl('/api/Communication/Create' + queryArg),
                    communication,
                    {
                        withCredentials: true,
                        responseType: 'json'
                    }
                )).data

                this.$bvModal.hide(this.MODAL_ID)
                General.showAlertSuccess("Creation successfully completed!", this)
            } catch (e) {

                General.showAlertDanger("The communication was not created!", this)
            }
            this.isSaveClicked = false;
        }
    }
    checkCountriesOrLocationsSelected(countriesIn: Array<CountriesShowed>):boolean{
        let result = false;
        countriesIn.forEach(item => {
            
            if (item.EXTERNAL || item.INTERNAL) {
                console.log("Trovato country "+item.name)
                result = true;
                return;

            }
            item.locations.forEach(loc => {
                
                if (loc.EXTERNAL || loc.INTERNAL) {
                    console.log("Trovato location "+loc.name)
                    result = true;
                    return;
                }

            });

        });
        return result;
    }
    getSelectedCountriesDtoCreation(countriesIn: Array<CountriesShowed>): Array<CreationCountryDto> {
        var countriesOut = new Array<CreationCountryDto>()
        countriesIn.forEach(item => {
            
                countriesOut.push({
                    Name: item.name,
                    locations: item.locations,
                    IdCountry: item.idCountry,
                    IsInternal: item.INTERNAL,
                    IsExternal: item.EXTERNAL,
                });
                
           

        });
        return countriesOut;

    }
    getSelectedCountriesDtoUpdating(countriesIn: Array<CountriesShowed>, countriesInComm: Array<any>): Array<UpdatingCountryDto> {
        var countriesOut = new Array<UpdatingCountryDto>()

        countriesIn.forEach(item => {      
                  
            countriesOut.push({
                IdCountry: item.idCountry,
                IsAdded: true,
                IsRemoved: false,
                Name: item.name,
                isInternal: item.INTERNAL,
                isExternal: item.EXTERNAL,                
                locations: (item.showLocations)?item.locations:[]

            });
        });

        if (countriesInComm != null) {

            countriesInComm.forEach(item => {

                if (!countriesIn.find(x => x.idCountry == item.idCountry)) {

                    countriesOut.push({
                        IdCountry: item.idCountry,
                        IsAdded: true,
                        IsRemoved: false,
                        Name: item.name,
                        isInternal: item.isInternal,
                        isExternal: item.isExternal,
                        locations: null
                    });
                }


            });

        }

        return countriesOut;

    }
    getAttachmentDtoUpdating(attahmentsIn: Array<UpdatingAttachmentDto>): Array<UpdatingAttachmentDto> {
        return attahmentsIn;

    }

    getAttachmentDtoCreating(attahmentsIn: Array<UpdatingAttachmentDto>): Array<CreationAttachmentDto> {
        let attachmanetsOut: Array<CreationAttachmentDto> = [];
        attahmentsIn.forEach(el =>
            attachmanetsOut.push({
                SessionId: el.SessionId
            })
        )

        return attachmanetsOut;

    }
    // get userCanManageCommunications() {            
    //     return General.CheckAuthorization(ClaimEnum.CanManageCommunications);
    // }
    get placeHolderDynaimc() {
        if (this.userCanManageCommunications) return "Insert Data";
        return "";

    }
    selectAll(contract: any) {
        let contractType = contract.value;
        this.countryList.forEach((country: any) => {
            country[contractType] = contract.selected;
            country.locations.forEach((loc: any) => {
                loc[contractType] = contract.selected;

            });
        })
    }




    setUserCanManageCommunications() {
        if (General.CheckAuthorization(ClaimEnum.CanManageCommunications)) {
            this.userCanManageCommunications = true;
        } else {
            if (this.id == null) {
                if (General.CheckAuthorization(ClaimEnum.CanManageCommunicationsForCountry)) {
                    this.userCanManageCommunications = true;
                }
            } else {
                this.completeCommunicationInfo.specificInfoDto.countries.forEach((c) => {
                    if (General.CheckAuthorizationAndClaimValue(ClaimEnum.CanManageCommunicationsForCountry, c.code)) {
                        this.userCanManageCommunications = true;
                        return;
                    }
                });
            }
        }
    }

    async mounted() {
        
        this.contractTypesOptions = await this.getContractTypes();
        this.countryList = await this.getCountries(true);

        if (this.id == null) {
            
            await this.fetchCommunicationCategories();
            this.completeCommunicationInfo = {
                readingCommunicationDto: {
                    id: null,
                    numericId: null,
                    text: null,
                    title: null,
                    author: null,
                    creationDate: null,
                    startDisplayDate: null,
                    endDisplayDate: null,
                    rowVersion: null,
                    //linkName: null,
                    linkUrl: null,
                    sendEmailNotification: null,
                    category: new CommunicationCategory(),
                    subCategory: {
                        idSubCategory: null,
                        idCategory: null,
                        name: null,
                        communicationCategory: new CommunicationCategory()
                    },
                    readingConfirmation: {
                        id: null,
                        isAcknowledgment: null,
                        isMandatory: false,
                        rowVersion: null
                    }
                },
                specificInfoDto: {
                    attachments: new Array<any>(),
                    countries: null,
                    locations: null
                }

            }

        } else {
            
            await this.viewCommunicationDetail(this.id)
          
            if (this.communicationSubCategoriesOptions.length > 0)
                this.communicationSubCategoriesOptions.splice(0);
              
            await this.setSubCategoriesOptions(this.completeCommunicationInfo.readingCommunicationDto.category.idCategory);
          
            this.checkBoxValues();
          
        }

        this.setUserCanManageCommunications();
      
    }
    //Devo ciclare sulle country della completeCommunication e se isInternal è true devo flaggarlo lo stesso per IsExternal (di this.countryList)
    checkBoxValues() {
        let app = this;
        this.completeCommunicationInfo.specificInfoDto.countries.forEach(function (commCountry) {
            app.countryList.forEach(function (country) {
                if (commCountry.name.toLowerCase() == country.name.toLowerCase())
                    country.INTERNAL = commCountry.isInternal,
                        country.EXTERNAL = commCountry.isExternal
            })
        })

    }
    get showFileTab(): boolean {
        if (this.completeCommunicationInfo.readingCommunicationDto.category.communicationType.canHaveAttachments == true) {
            if (this.userCanManageCommunications == true) return true;
            if (this.completeCommunicationInfo.specificInfoDto.attachments.length > 0) return true;
        }
        return false;

    }

    setOptions(
        arrayTarget: any[],
        arraySource: any[],
        aliasId: string,
        aliasValue: string,
        pushEmptyItem: boolean = true
    ): any[] {
        if (pushEmptyItem) arrayTarget.push({ value: null, text: "" });
        arraySource.forEach(function (el: any) {
            arrayTarget.push({ value: el[aliasId], text: el[aliasValue] });
        });
        return arrayTarget;
    }

    onFocus(quill) {
        this.quillEditor = quill;
    }

    onBlur() {
        this.quillEditor = null;
    }

    onPaste(evt) {
        if (this.quillEditor !== null) {
            let Editor = this.quillEditor;
            var items = evt.clipboardData.items;
            var blob;

            for (var i = 0; i < items.length; i++) {
                if (items[i].type.indexOf("image") >= 0) {
                    blob = items[i].getAsFile();
                }
            }
            if (blob !== undefined) {
                evt.preventDefault();
                this.handleImageAdded(blob, Editor, null);
            }
        }
    }
}

